import { render, staticRenderFns } from "./zoneStyle2.vue?vue&type=template&id=0ed920f2&scoped=true&"
import script from "./zoneStyle2.vue?vue&type=script&lang=ts&"
export * from "./zoneStyle2.vue?vue&type=script&lang=ts&"
import style0 from "./zoneStyle2.vue?vue&type=style&index=0&id=0ed920f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed920f2",
  null
  
)

export default component.exports